import { render, staticRenderFns } from "./ObjectPageDesktop.vue?vue&type=template&id=4446ab10"
import script from "./ObjectPageDesktop.vue?vue&type=script&lang=js"
export * from "./ObjectPageDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports